import { useDispatch, useSelector } from 'react-redux';
import { QuickFilter, ResultsType } from '../types';
import { setDrawerOpen, setQuickFilter } from '../../../redux/slices/mapSlice';
import { SearchFiltersActionTypes } from '../../../reducers/search-filters/actions';
import { SearchFiltersTypes } from '../../../reducers/search-filters/reducer';
import { useContext } from 'react';
import {
  SearchContext,
  SearchContextInterface
} from '../../search-new/context/SearchContext';
import { updateQuery } from '../../../helpers/common';
import { useRouter } from 'next/router';

const useFilterActions = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const quickFilter = useSelector((state: any) => state.map.quickFilter);
  const resultsType = useSelector((state: any) => state.map.resultsType);
  const { searchFiltersState, searchFiltersDispatch } = useContext(
    SearchContext
  ) as SearchContextInterface;

  const applyFilters = () => {
    dispatch(setQuickFilter(null));
    if (resultsType == ResultsType.COMPOUNDS) {
      dispatch(setDrawerOpen(true));
    }
  };

  const resetFilters = (type?: QuickFilter) => {
    if (
      (quickFilter === QuickFilter.PROPERTY_TYPE ||
        type === QuickFilter.PROPERTY_TYPE) &&
      searchFiltersState.searchFilters.property_types.length > 0
    ) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
        payload: {
          name: SearchFiltersTypes.PROPERTY_TYPES,
          value: []
        }
      });
      updateQuery(router, undefined, ['property_types'], true);
    }

    if (
      (quickFilter === QuickFilter.PRICE || type === QuickFilter.PRICE) &&
      (searchFiltersState.searchFilters.min_price ||
        searchFiltersState.searchFilters.max_price)
    ) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.MIN_PRICE,
          value: undefined
        }
      });

      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.MAX_PRICE,
          value: undefined
        }
      });
      updateQuery(router, undefined, ['min_price', 'max_price'], true);
    }

    if (
      (quickFilter === QuickFilter.DELIVERY || type === QuickFilter.DELIVERY) &&
      searchFiltersState.searchFilters.delivery_years &&
      !searchFiltersState.searchFilters.nawy_now
    ) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_MULTISELECT,
        payload: {
          name: SearchFiltersTypes.DELIVERY_YEARS,
          value: []
        }
      });
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.DELIVERY_DATE,
          value: undefined
        }
      });
      updateQuery(router, undefined, ['delivery_date', 'delivery_years'], true);
    }

    if (
      (quickFilter === QuickFilter.NAWY_NOW || type === QuickFilter.NAWY_NOW) &&
      searchFiltersState.searchFilters.nawy_now
    ) {
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.NAWY_NOW,
          value: false
        }
      });
      searchFiltersDispatch({
        type: SearchFiltersActionTypes.UPDATE_FILTERS_WITH_SINGLE_VALUE,
        payload: {
          name: SearchFiltersTypes.DELIVERY_DATE,
          value: undefined
        }
      });
      updateQuery(router, undefined, ['nawy_now', 'delivery_date'], true);
    }
  };

  return { applyFilters, resetFilters };
};

export default useFilterActions;
